import * as React from 'react';

import GridNew from 'components/grid/GridNew';
import { Loader } from 'components/loader/Loader';
import { STATUSES } from 'core/api';
import { useAppDispatch, useAppSelector } from 'core/store/createStore';

import { gridConfig } from './config';
import { IProps } from './interfaces';
import { fetchUsers } from './redux';

import styles from './Users.module.styl';
import qs from 'qs';
import { UserTypes } from 'core/auth/constants';
import Filters from '../../../components/filters/users/filters';
import IconButton from '@material-ui/core/IconButton';
import FilterListIcon from '@material-ui/icons/FilterList';

const Users: React.FC<IProps> = ({ location, history }) => {
  const { search, hash } = location;
  const selectedUserTypesQuery = qs.parse(search.slice(1))['userTypes'];
  const [selectedUserTypes, setSelectedUserTypes] = React.useState(
    selectedUserTypesQuery || Object.values(UserTypes),
  );
  const [filtersEnabled, setFiltersEnabled] = React.useState(true);
  const dispatch = useAppDispatch();
  const users = useAppSelector(state => state.userList);

  const handleSearch = (searchPhrase: string) => {
    history.push(`/admin/users#${searchPhrase}`);
  };
  const handleFilterReset = () => {
    setSelectedUserTypes(Object.values(UserTypes));
  };
  const onFilterIconClick = () => {
    setFiltersEnabled(state => !state);
  };
  const handleFilterChange = (filters: string[]) => {
    setSelectedUserTypes([...filters]);
  };
  const handleUserTypeChange = (
    // @ts-ignore
    { target: { value: checkBoxValue } },
    searchPhrase: string,
  ) => {
    const filterUserList = (newfilters: string[]) => {
      const urlPrefix = '/admin/users/';

      const filterParams =
        newfilters.length > 0 ? qs.stringify({ userTypes: newfilters }) : '';

      history.push(
        `${urlPrefix}?${filterParams}${searchPhrase ? `#${searchPhrase}` : ''}`,
      );

      handleFilterChange(newfilters);
    };

    if (selectedUserTypes.includes(checkBoxValue)) {
      const rest = selectedUserTypes.filter((v: string) => v !== checkBoxValue);
      filterUserList(rest);
    } else {
      filterUserList([...selectedUserTypes, checkBoxValue]);
    }
  };

  React.useEffect(() => {
    const params = qs.parse(search?.slice(1) as string);
    const pagination = {
      page: +params.page || 0,
      limit: +params.limit || 10,
    };
    const userTypes =
      qs.parse(search.slice(1))['userTypes'] || Object.values(UserTypes);
    const searchPhrase = hash ? hash.split('#')[1] : '';
    const isActiveUser = userTypes.includes(UserTypes.ACTIVE);

    dispatch(
      fetchUsers({
        searchPhrase,
        pagination,
        userTypes,
        isActiveUser,
      }),
    );
  }, [dispatch, hash, search]);
  React.useEffect(() => {
    const selectedUserTypesQuery = qs.parse(search.slice(1))['userTypes'];

    setSelectedUserTypes(selectedUserTypesQuery || Object.values(UserTypes));
    setFiltersEnabled(true);
  }, [search]);

  const searchPhrase = location.hash ? location.hash.split('#')[1] : '';

  switch (users.status) {
    case STATUSES.REQUEST:
      return <Loader />;
    case STATUSES.FAILED:
      return <div>{users.error}</div>;
    case STATUSES.SUCCESS:
      return (
        <div className={styles.root}>
          <GridNew
            pagination={users.data.pagination}
            data={users.data.items}
            config={gridConfig}
            urlPrefix="/admin/users"
            onSearch={handleSearch}
            searchPhrase={searchPhrase}
            onFilterReset={handleFilterReset}
            filterName="userTypes"
            filterPanelIcon={() => (
              <IconButton aria-label="Filter" onClick={onFilterIconClick}>
                <FilterListIcon />
              </IconButton>
            )}
            filterPanel={() =>
              filtersEnabled && (
                <Filters
                  // @ts-ignore
                  handleChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >,
                  ) => handleUserTypeChange(event, searchPhrase)}
                  selectedUserTypes={selectedUserTypes}
                />
              )
            }
          />
        </div>
      );
    default:
      return null;
  }
};

export default Users;
